$(document).on('turbolinks:load', function() {
    $('.dashboard_tables').DataTable({
        "scrollX": true,
        "searching": false,
        "paging": false,
        "bSort": false,
        "bInfo" : false
    });
});